import { ConfigStateService } from '@abp/ng.core';
import { fadeIn } from '@abp/ng.theme.shared';
import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nh-profile',
  templateUrl: './nh-profile.component.html',
  styleUrls: ['./nh-profile.component.scss'],
  animations: [trigger('fadeIn', [transition(':enter', useAnimation(fadeIn))])],
  styles: [
    `
      .min-h-400 {
        min-height: 400px;
      }
    `,
  ],
})
export class NhProfileComponent implements OnInit {
  selectedTab: number = 0;
  currentUser: any = {};
  roles: any = [];

  constructor(
    private configStateService: ConfigStateService
  ) {}

  ngOnInit() {
    let state = this.configStateService.getAll();
    this.currentUser = state.currentUser;

    this.currentUser.roles.forEach(element => {
      this.roles.push({ "roles": element});
    });
  }
}